<template>
  <div class="position-relative">
    <div class="sub-title">Materiaal</div>

    <div v-if="disablePanelInput" class="cancel-input" @click="cancelInput">
      <font-awesome-icon class="font-awesome-icon action times" icon="times"/>
      &nbsp;&nbsp;Invoer annuleren
    </div>

    <app-filter-first/>
    <app-filter-deliveryprogram/>
    <app-filter-second/>
    <app-filter-third/>

    <!--    <app-filter name="Filter 2" filter_index="2"/>-->

    <!--    <app-filter name="Filter 3" filter_index="3"/>-->

    <!--    <app-type/>-->
    <!--    <app-core/>-->

    <app-thickness/>

    <app-side @searchSides="searchSides(1)" :side="1" ref="appSide1"/>
    <app-side @searchSides="searchSides(2)" :side="2" ref="appSide2"/>

    <app-search-sides @selectSide="selectSide" ref="appSearchSides" :side="selectedSide"/>

    <app-finish/>

    <app-summary/>

    <app-textmessages/>
  </div>
</template>

<script>
  // import Type from '@/components/Tool/Materials/Type.vue'
  // import Core from '@/components/Tool/Materials/Core.vue'
  import { REMOVE_MATERIAL } from '../../../store/types'
  import FilterDeliveryProgram from '@/components/Tool/Materials/FilterDeliveryProgram.vue'
  import FilterFirst from '@/components/Tool/Materials/FilterFirst.vue'
  import FilterSecond from '@/components/Tool/Materials/FilterSecond.vue'
  import FilterThird from '@/components/Tool/Materials/FilterThird.vue'
  import Thickness from '@/components/Tool/Materials/Thickness.vue'
  import Side from '@/components/Tool/Materials/Side.vue'
  import Finish from '@/components/Tool/Materials/Finish.vue'

  import SearchSides from '@/components/Tool/Materials/SearchSides.vue'
  import Summary from '@/components/Tool/Materials/Summary.vue'
  import Textmessages from '@/components/Global/Textmessages.vue'

  export default {
    components: {
      'app-filter-deliveryprogram': FilterDeliveryProgram,
      'app-filter-first': FilterFirst,
      'app-filter-second': FilterSecond,
      'app-filter-third': FilterThird,
      'app-thickness': Thickness,
      'app-side': Side,
      'app-search-sides': SearchSides,
      'app-finish': Finish,
      'app-summary': Summary,
      'app-textmessages': Textmessages
    },
    data() {
      return {
        selectedSide: 1
      }
    },
    computed: {
      disablePanelInput() {
        return this.$store.getters.disablePanelInput
      }
    },
    methods: {
      cancelInput() {
        if (this.$store.getters.cartMaterials.length === 1) {
          // Return to the dashboard
          this.$router.push({ path: 'dashboard' })
        } else {
          // Return to the last material
          this.$store.dispatch(REMOVE_MATERIAL, this.$store.getters.material)
        }
      },
      searchSides(side) {
        this.selectedSide = side
        this.$refs.appSearchSides.showModal()
      },
      selectSide(code) {
        this.$refs['appSide' + this.selectedSide].selectSide(code)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cancel-input {
     display: inline-block;
     position: absolute;
     top: 5px;
     right: 0;
     padding: 3px 10px;
     color: #808080;
     background-color: #fafafa;
     border: 1px solid rgba(0, 0, 0, 0.125);
     border-radius: 5px;
     cursor: pointer;
  }
  .cancel-input:hover {
    background-color: #f2f2f2;
    color: #000;
  }
  .cancel-input:hover .times {
    transform: rotate(90deg);
  }
  .cancel-input .times {
    transition: transform 0.5s ease 0s;
  }
</style>
